import Promise from 'bluebird';
import _ from 'lodash';
import axios from 'axios';

import { getDateRangeFilter, getInWithNullFilter } from 'utils/filter-utils';
import Rest from 'services/data/rest';

class Invoice extends Rest {
  static path = 'invoice';
  static defaultQuery = {
    sort: 'invoiceNumber DESC',
    load: ['company', 'company.billingEmails', 'company.billingAddress', 'pdf'],
    // Set the limit higher for the invoices page in order to make sending invoices easier
    limit: 100
  };

  static mapFilters(filters) {
    const {
      company,
      invoiceMethod,
      paymentMethod,
      dueDate,
      invoiceDate,
      invoiceStatus,
      achStatus,
      id,
      invoiceNumber,
      team,
      paymentStatus
    } = filters;

    // If the id filter is applied, ignore all other filters
    // (and turn off the api's default status filtering)
    if (id) return { id, status: { '!': null } };

    return _.assign({
      company,
      'company.team': team,
      deliveryMethod: getInWithNullFilter(invoiceMethod),
      paymentMethod: getInWithNullFilter(paymentMethod),
      dueDate: getDateRangeFilter(dueDate),
      invoiceDate: getDateRangeFilter(invoiceDate),
      id,
      achProcessedDate: getACHStatusFilter(achStatus),
      balance: getBalanceFilter(paymentStatus),
      invoiceNumber: { contains: invoiceNumber }
    }, getDeliveryDateFilter(invoiceStatus));
  }

  static createMany(invoices) {
    return Promise.resolve(axios.post('/api/invoice/createmany', invoices))
      .tap(this.logRequest)
      .then((response) => response.data);
  }

  static getPDF(id) {
    return Promise.resolve(axios.get(`/api/invoice/${id}/render`))
      .tap(this.logRequest)
      .then((response) => response.data);
  }

  static emailInvoices(invoiceIds) {
    return Promise.resolve(axios.post('/api/invoice/emailinvoices', invoiceIds))
      .tap(this.logRequest)
      .then((response) => response.data);
  }

  static checkBalances() {
    return Promise.resolve(axios.post('/api/invoice/check-balances'))
      .tap(this.logRequest);
  }
}

function getDeliveryDateFilter(status) {
  const delivered = _.includes(status, 'Delivered');
  const notDelivered = _.includes(status, 'Not Delivered');

  if (delivered && !notDelivered) {
    return {
      and: {
        emailedDate: { '!': null },
        or: {
          mailedDate: { '!': null },
          deliveryMethod: 'Email'
        }
      }
    };
  }

  if (notDelivered && !delivered) {
    return {
      or: {
        emailedDate: null,
        and: {
          mailedDate: null,
          deliveryMethod: 'Mail'
        }
      }
    };
  }
}

function getACHStatusFilter(status) {
  const processed = _.includes(status, 'ACH Processed');
  const notProcessed = _.includes(status, 'ACH Not Processed');

  if (processed && !notProcessed) return { '!': null };
  if (notProcessed && !processed) return null;
}

function getBalanceFilter(status) {
  const paid = _.includes(status, 'Paid');
  const unpaid = _.includes(status, 'Unpaid');

  if (paid && !unpaid) return 0;
  if (!paid && unpaid) return { '>': 0 };
}

// Exports
export default Invoice;



// WEBPACK FOOTER //
// ./app/services/data/invoice.js